import NavDetails from "components/Elements/NavDetails";
import ActionButtonStyle from "styles/application/ActionButtonStyle";
import AccessWrapper from "components/Modules/AccessWrapper";
import { NoReadOnly } from "helpers/constants";
import PrintIcon from "assets/printer.svg";
import CommonDropdown from "components/Elements/CommonDropdown";
import HtmlTooltip from "components/Elements/HtmlTooltip";
import { makeStyles } from "tss-react/mui";
import { useState } from "react";
import {
	ScheduleReportModal,
	buildScheduleReportFooterItem,
	useScheduleReportModal,
	ReportGenerationDialog,
} from "components/Modules/ReportSubscriptions";
import { useCreateReportSubscription } from "components/Modules/ReportSubscriptions/hooks/useCreateReportSubscription";
import { useReportFilterContext } from "components/Modules/ReportSubscriptions/hooks/useReportFilterContext";
import {
	formValuesToApiRequest,
	toApiReportType,
} from "services/reportSubscriptions";

const AT = ActionButtonStyle();

const media = "@media (max-width: 414px)";

const useStyles = makeStyles()((theme) => ({
	restore: {
		border: "2px solid",
		borderRadius: "100%",
		height: "35px",
		width: "35px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: "#307ad6",
	},

	buttons: {
		display: "flex",
		marginLeft: "auto",
		[media]: {
			marginLeft: "0px",
			flexDirection: "column",
			marginBottom: "10px",
			gap: "10px",
		},
	},
	wrapper: {
		display: "flex",
		[media]: {
			marginTop: "10px",
			justifyContent: "space-between",
			flexDirection: "column",
		},
	},
	importButton: { background: "#ED8738" },
}));

const importButton = {
	"&.MuiButton-root": {
		backgroundColor: "#ED8738",
	},
};
function Header({
	setOpenAddService,
	setImportCSV,
	setOpenMultipleChnageStatusPopup,
	dataLength,
	MultipleChangeStatusDisabled,
	customCaptions,
	selectedServices,
}) {
	const { classes } = useStyles();
	const getReportFilterContext = useReportFilterContext();
	const [activeReportRequest, setActiveReportRequest] = useState(null);
	const closeReportDialog = () => setActiveReportRequest(null);

	const { position } = sessionStorage.getItem("me")
		? JSON.parse(sessionStorage.getItem("me"))
		: {};

	const serviceReports = [
		{
			id: "1",
			name: `${customCaptions?.servicePlural || "Services"} Report`,
			reportType: "SERVICE_REPORT",
		},
		{
			id: "2",
			name: `${customCaptions?.servicePlural || "Services"} Excel`,
			reportType: "SERVICE_EXCEL",
		},
		{
			id: "3",
			name: "CM Data Export",
			reportType: "CM_DATA_EXPORT",
		},
	];

	const scheduleModal = useScheduleReportModal();
	const createSubscription = useCreateReportSubscription();
	const handleScheduleSubmit = async (payload) => {
		const apiBody = formValuesToApiRequest(payload, payload.filterValues, payload.filterSummary);
		await createSubscription(apiBody);
	};

	const handleReportClick = (report, handleClose) => {
		if (!report || Object.keys(report).length < 1) return;
		handleClose();
		setActiveReportRequest({
			reportName: report.name,
			body: {
				reportType: toApiReportType(report.reportType),
				filterContext: getReportFilterContext(),
				name: null,
				recipientEmail: null,
				sendEmail: false,
			},
		});
	};

	return (
		<div className={"topContainerCustomCaptions"}>
			<NavDetails
				status={false}
				lastSaved={""}
				staticCrumbs={[
					{
						id: 1,
						name: `${customCaptions.servicePlural} (${dataLength})`,
						url: "",
					},
				]}
				hideLastLogin
				hideLastSave
				hideVersion={true}
			/>
			{activeReportRequest ? (
				<ReportGenerationDialog
					open
					onClose={closeReportDialog}
					reportName={activeReportRequest.reportName}
					body={activeReportRequest.body}
				/>
			) : null}
			<div className={classes.wrapper}>
				<div className={classes.buttons}>
					<AccessWrapper
						access={position?.serviceAccess}
						accessList={NoReadOnly}
					>
						{MultipleChangeStatusDisabled && selectedServices.length > 0 ? (
							<HtmlTooltip
								title={`The status of your selected ${customCaptions.servicePlural} can not be changed as they are not the same status`}
							>
								<div>
									<AT.GeneralButton
										sx={importButton}
										onClick={() => setOpenMultipleChnageStatusPopup(true)}
										disabled={MultipleChangeStatusDisabled}
									>
										Change Status
									</AT.GeneralButton>
								</div>
							</HtmlTooltip>
						) : (
							<AT.GeneralButton
								sx={importButton}
								onClick={() => setOpenMultipleChnageStatusPopup(true)}
								disabled={MultipleChangeStatusDisabled}
							>
								Change Status
							</AT.GeneralButton>
						)}
					</AccessWrapper>

					<AccessWrapper
						access={position?.serviceAccess}
						accessList={NoReadOnly}
					>
						<AT.GeneralButton
							sx={importButton}
							className={classes.importButton}
							onClick={() => setImportCSV(true)}
						>
							Import from CSV
						</AT.GeneralButton>
					</AccessWrapper>


					<AccessWrapper
						access={position?.serviceAccess}
						accessList={NoReadOnly}
					>
						<AT.GeneralButton onClick={() => setOpenAddService(true)}>
							Add New
						</AT.GeneralButton>
					</AccessWrapper>

					<CommonDropdown
						iconSrc={PrintIcon}
						isDownloading={false}
						dataSource={serviceReports}
						dynamicAction={handleReportClick}
						footerItem={buildScheduleReportFooterItem(scheduleModal.openModal)}
					/>
				</div>
				{/* <div className="restore">
					<Icon className={classes.restore} name="Restore" />
				</div> */}
			</div>
			{scheduleModal.open ? (
				<ScheduleReportModal
					open
					onClose={scheduleModal.closeModal}
					availableReports={serviceReports}
					initialValues={scheduleModal.initialValues}
					onSubmit={handleScheduleSubmit}
				/>
			) : null}
		</div>
	);
}

export default Header;
